import { combineReducers } from 'redux';

import esnMappingGrid from './grid/redux/reducer';
import esnMappingModal from './modal-upload/redux/reducer';

export default combineReducers({
  grid: esnMappingGrid,
  modal: esnMappingModal
});
